import { createElement, createRef, RefObject, ReactNode } from 'react';
import { BaseTableCellData } from './BaseTableCellData';
import { TableItemData } from './internal';
import { TableColumnProps } from '../shared';
import { BaseTableProps } from './BaseTableProps';
import { BaseTableColumnProps } from './BaseTableColumnProps';
import { CellContent } from './CellContent';

export interface ContentProps {
  itemData: BaseTableCellData;
  content: ReactNode | NonNullable<BaseTableColumnProps['cellContent']>;
  disabled: BaseTableProps['disabled'];
  readOnly: BaseTableProps['readOnly'];
  rowIndex: number;
  columnIndex: number;
}

export const RowCellContent = ({
  content,
  rowIndex,
  columnIndex,
  disabled,
  readOnly,
  ...props
}: ContentProps) => {
  const itemData = props.itemData as TableItemData;
  const { updateControlRefs, getRowIdentifier, columns } = itemData;
  const column: TableColumnProps = columns[columnIndex];
  const rowKey = getRowIdentifier(rowIndex);
  const columnKey = column?.key;

  if (typeof content === 'function') {
    const ref: RefObject<any> = createRef();
    updateControlRefs(columnKey, rowKey, ref);

    let focusCellContent = itemData.preference?.scrollPosition?.editOnFocus;
    if (focusCellContent) {
      const cellToFocus = itemData.preference?.scrollPosition?.cell;
      const rowIndex = cellToFocus?.rowIndex;
      const colIndex = cellToFocus?.colIndex;
      const colKey = colIndex !== undefined ? itemData.columns[colIndex].key : '';
      focusCellContent = rowIndex === rowIndex && colKey === columnKey;
    }

    return (
      <CellContent
        itemData={itemData}
        rowIndex={rowIndex}
        columnKey={columnKey}
        className={column.cellContainerClassName}
        style={column.cellContainerStyle}
        focus={focusCellContent}
        contentRef={ref}
      >
        {content(columnIndex, rowIndex, columnKey, ref, disabled, readOnly)}
      </CellContent>
    );
  }

  return (
    <CellContent
      itemData={itemData}
      rowIndex={rowIndex}
      columnKey={columnKey}
      className={column.cellContainerClassName}
      style={column.cellContainerStyle}
    >
      {content}
    </CellContent>
  );
};
